module.exports = [{"alias":"system","name":"系统管理","children":[{"name":"组织架构","children":[{"name":"用户管理","route":"/user","authCode":"xcrm.manage.user","order":1},{"name":"部门管理","route":"/department","authCode":"xcrm.manage.department","order":2}]}]}]


//////////////////
// WEBPACK FOOTER
// ./src/layout/sysMenus.json
// module id = rlSv
// module chunks = 39